import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Tree,
  Row,
  Col,
  Space,
  Button,
  message,
  Popconfirm,
  Typography,
  Spin,
} from "antd";
import React, { useState, useEffect } from "react";
import styles from "./Unit.module.css";
import {
  ClassIcon,
  GradeIcon,
  HospitalIcon,
  SchoolIcon,
} from "../../common";
import { AddHospital,AddSchool,AddGrade,AddClass,EditHospital,EditSchool,EditGrade,EditClass } from "../../components/setting";
import { deleteTable, getLogoByHospital, getTableAll } from "../../api/Api";
import { Hospital, initHospital,initSchool, School,Grade, initGrade,Class, initClass } from "../../models";
import { useHistory } from "react-router-dom";
import { HospitalLogo, initHospitalLogo } from "../../models/HospitalLogo";

export const Unit: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("");
  const [hospitals, setHospitals] = useState<Hospital[]>([]);
  const [schools, setSchools] = useState<School[]>([]);
  const [grades, setGrades] = useState<Grade[]>([]);
  const [classes, setClasses] = useState<Class[]>([]);

  const [currentHospital, setCurrentHospital] = useState(initHospital);
  const [currentHospitalLogo,setCurrentHospitalLogo]=useState(initHospitalLogo);
  const [currentSchool, setCurrentSchool] = useState(initSchool);
  const [currentGrade, setCurrentGrade] = useState(initGrade);
  const [currentClass, setCurrentClass] = useState(initClass);

  const [treeData, setTreeData] = useState<any[]>([]);
  const [addHospitalVisible, setAddHospitalVisible] = useState(false);
  const [addSchoolVisible, setAddSchoolVisible] = useState(false);
  const [addGradeVisible, setAddGradeVisible] = useState(false);
  const [addClassVisible, setAddClassVisible] = useState(false);
  const [editHospitalVisible, setEditHospitalVisible] = useState(false);
  const [editSchoolVisible, setEditSchoolVisible] = useState(false);
  const [editGradeVisible, setEditGradeVisible] = useState(false);
  const [editClassVisible, setEditClassVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const history = useHistory();
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    let hs: Hospital[] = await getTableAll("hospital");
    let ss: School[] = await getTableAll("school");
    let gs: Grade[] = await getTableAll("grade");
    let cs: Class[] = await getTableAll("class");
    if(typeof hs === "undefined" || typeof ss === "undefined" || typeof gs === "undefined" || typeof cs === "undefined"){
      history.push("/");      
    }
    setHospitals(hs);
    setSchools(ss);
    setGrades(gs);
    setClasses(cs);
    buildData(hs, ss, gs, cs);
    setLoading(false);
  };
  const hospitalAdd = (h: Hospital) => {
    let _hs = [...hospitals, h];
    buildData(_hs, schools, grades, classes);
    setHospitals(_hs);
  };
  const hospitalLogoAdd = (h: HospitalLogo) => {
  };
  
  const hospitalUpdate = (h: Hospital) => {
    let _hs: Hospital[] = [];
    hospitals.forEach((h1) => {
      if (h.id === h1.id) {
        _hs.push(h);
      } else {
        _hs.push(h1);
      }
    });
    buildData(_hs, schools, grades, classes);
    setHospitals(_hs);
    if (currentHospital.id === h.id) {
      setCurrentHospital(h);
    }
  };

  const hospitalLogoUpdate = (h: HospitalLogo) => {
    setCurrentHospitalLogo(h);
  }
  const schoolAdd = (s: School) => {
    let _ss = [...schools, s];
    buildData(hospitals, _ss, grades, classes);
    setSchools(_ss);
  };

  const schoolUpdate = async (s: School) => {
    let _ss: School[] = [];
    schools.forEach((s1) => {
      if (s.id === s1.id) {
        _ss.push(s);
      } else {
        _ss.push(s1);
      }
    });
    buildData(hospitals, _ss, grades, classes);
    setSchools(_ss);
    if (currentSchool.id === s.id) {
      setCurrentSchool(s);
    }
  };

  const gradeAdd = (g: Grade) => {
    let _gs = [...grades, g];
    buildData(hospitals, schools, _gs, classes);
    setGrades(_gs);
  };
  const gradeUpdate = (g: Grade) => {
    let _gs: Grade[] = [];
    grades.forEach((g1) => {
      if (g.id === g1.id) {
        _gs.push(g);
      } else {
        _gs.push(g1);
      }
    });
    buildData(hospitals, schools, _gs, classes);
    setGrades(_gs);
    if (currentGrade.id === g.id) {
      setCurrentGrade(g);
    }
  };

  const classAdd = (c: Class) => {
    let _cs = [...classes, c];
    buildData(hospitals, schools, grades, _cs);
    setClasses(_cs);
  };
  const classUpdate = (c: Class) => {
    let _cs: Class[] = [];
    classes.forEach((c1) => {
      if (c.id === c1.id) {
        _cs.push(c);
      } else {
        _cs.push(c1);
      }
    });
    buildData(hospitals, schools, grades, _cs);
    setClasses(_cs);
    if (currentClass.id === c.id) {
      setCurrentClass(c);
    }
  };

  const deleteConfirm = async () => {
    setLoading(true);
    if (type === "hospital") {
      await deleteTable("hospital", currentHospital.id);
      schools.forEach(async (s) => {
        if (s.hospitalId === currentHospital.id) {
          await deleteTable("school", s.id);
          grades.forEach(async (g) => {
            if (g.schoolId === s.id) {
              await deleteTable("grade", g.id);
              classes.forEach(async (c) => {
                if (c.gradeId === g.id) {
                  await deleteTable("class", c.id);
                }
              });
            }
          });
        }
      });

      getData();
      setCurrentHospital(initHospital);
      setCurrentSchool(initSchool);
      setCurrentGrade(initGrade);
      setCurrentClass(initClass);
    } else if (type === "school") {
      await deleteTable("school", currentSchool.id);
      grades.forEach(async (g) => {
        if (g.schoolId === currentSchool.id) {
          await deleteTable("grade", g.id);
          classes.forEach(async (c) => {
            if (c.gradeId === g.id) {
              await deleteTable("class", c.id);
            }
          });
        }
      });

      getData();
      setCurrentSchool(initSchool);
      setCurrentGrade(initGrade);
      setCurrentClass(initClass);
    } else if (type === "grade") {
      await deleteTable("grade", currentGrade.id);
      classes.forEach(async (c) => {
        if (c.gradeId === currentGrade.id) {
          await deleteTable("class", c.id);
        }
      });

      getData();
      setCurrentGrade(initGrade);
      setCurrentClass(initClass);
    } else if (type === "class") {
      await deleteTable("class", currentClass.id);
      getData();
      setCurrentClass(initClass);
    }
    setLoading(false);
    setDeleteVisible(false);
  };
  const deleteCancel = () => {
    setDeleteVisible(false);
  };
  const onSelect = async (selectedKeys: React.Key[], info: any) => {
    //console.log('selected', selectedKeys, info);
    let keyStr = selectedKeys[0].toString();
    let type = "",
      id;
    let fields = keyStr.split("-");
    type = fields[0];
    setType(type);
    id = parseInt(fields[1]);
    if (type === "hospital") {
      let hospital = hospitals.find((h) => h.id === id);
      if (typeof hospital !== "undefined") {
        setCurrentHospital(hospital);
        setCurrentHospitalLogo(await getLogoByHospital(hospital.id));
        setCurrentSchool(initSchool);
        setCurrentGrade(initGrade);
        setCurrentClass(initClass);
      }
    } else if (type === "school") {
      let school = schools.find((s) => s.id === id);
      let hospital = hospitals.find((h) => h.id === school?.hospitalId);
      if (typeof hospital !== "undefined" && typeof school !== "undefined") {
        setCurrentHospital(hospital);
        setCurrentHospitalLogo(await getLogoByHospital(hospital.id));
        setCurrentSchool(school);
        setCurrentGrade(initGrade);
        setCurrentClass(initClass);
      }
    } else if (type === "grade") {
      let grade = grades.find((g) => g.id === id);
      let school = schools.find((s) => s.id === grade?.schoolId);
      let hospital = hospitals.find((h) => h.id === school?.hospitalId);
      if (
        typeof grade !== "undefined" &&
        typeof school !== "undefined" &&
        typeof hospital !== "undefined"
      ) {
        setCurrentHospital(hospital);
        setCurrentHospitalLogo(await getLogoByHospital(hospital.id));
        setCurrentSchool(school);
        setCurrentGrade(grade);
        setCurrentClass(initClass);
      }
    } else if (type === "class") {
      let class1 = classes.find((c) => c.id === id);
      let grade = grades.find((g) => g.id === class1?.gradeId);
      let school = schools.find((s) => s.id === grade?.schoolId);
      let hospital = hospitals.find((h) => h.id === school?.hospitalId);
      if (
        typeof class1 !== "undefined" &&
        typeof grade !== "undefined" &&
        typeof school !== "undefined" &&
        typeof hospital !== "undefined"
      ) {
        setCurrentHospital(hospital);
        setCurrentHospitalLogo(await getLogoByHospital(hospital.id));
        setCurrentSchool(school);
        setCurrentGrade(grade);
        setCurrentClass(class1);
      }
    }
  };

  const buildData = async (
    hs: Hospital[],
    ss: School[],
    gs: Grade[],
    cs: Class[]
  ) => {
    let _treeData: any[] = [];
    hs.forEach((d) => {
      let _hospital: any = {
        title: d.hospitalName,
        key: "hospital-" + d.id,
        icon: <HospitalIcon />,
      };
      let _hospitalChildren: any[] = [];
      ss.forEach((d1) => {
        if (d1.hospitalId === d.id) {
          let _school: any = {
            title: d1.schoolName,
            key: "school-" + d1.id,
            icon: <SchoolIcon />,
          };
          let _schoolChildren: any[] = [];
          gs.forEach((d2) => {
            if (d2.schoolId === d1.id) {
              let _grade: any = {
                title: d2.gradeName,
                key: "grade-" + d2.id,
                icon: <GradeIcon />,
              };
              let _gradeChildren: any[] = [];
              cs.forEach((d3) => {
                if (d3.gradeId === d2.id) {
                  let _class = {
                    title: d3.className,
                    key: "class-" + d3.id,
                    icon: <ClassIcon />,
                  };
                  _gradeChildren.push(_class);
                }
              });
              if (_gradeChildren.length > 0) {
                _grade.children = _gradeChildren;
              }
              _schoolChildren.push(_grade);
            }
          });
          if (_schoolChildren.length > 0) {
            _school.children = _schoolChildren;
          }
          _hospitalChildren.push(_school);
        }
      });
      if (_hospitalChildren.length > 0) {
        _hospital.children = _hospitalChildren;
      }
      _treeData.push(_hospital);
    });

    setTreeData(_treeData);
  };
  return (
    <div className={styles["unitMain"]}>
      <Typography.Title className={styles["title"]} level={5}>
        医院、学校设置
      </Typography.Title>
      {loading && <Spin />}
      {!loading && (
        <>
          <Row justify="center">
            <Col span={8}>
              <Tree
                className={styles["tree"]}
                showLine={true}
                showIcon={true}
                onSelect={onSelect}
                treeData={treeData}
              />
            </Col>
            <Col span={6}>
              <Space direction="vertical">
                <Button
                  className={styles["button"]}
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => setAddHospitalVisible(true)}
                >
                  增加医院
                </Button>
                <Button
                  className={styles["button"]}
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (currentHospital.id < 0) {
                      message.warning(
                        "请在左边的机构列表中选择一个医院,再增加学校!"
                      );
                    } else {
                      setAddSchoolVisible(true);
                    }
                  }}
                >
                  增加学校
                </Button>
                <Button
                  className={styles["button"]}
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (currentSchool.id >= 0) {
                      setAddGradeVisible(true);
                    } else {
                      message.warning(
                        "请在左边的机构列表中选择一个学校,再增加年级!"
                      );
                    }
                  }}
                >
                  增加年级
                </Button>
                <Button
                  className={styles["button"]}
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (currentGrade.id >= 0) {
                      setAddClassVisible(true);
                    } else {
                      message.warning(
                        "请在左边的机构列表中选择一个年级,再增加班级!"
                      );
                    }
                  }}
                >
                  增加班级
                </Button>
                <Button
                  className={styles["button"]}
                  ghost
                  type="primary"
                  shape="round"
                  icon={<EditOutlined />}
                  onClick={() => {
                    if (type === "hospital") {
                      setEditHospitalVisible(true);
                    } else if (type === "school") {
                      setEditSchoolVisible(true);
                    } else if (type === "grade") {
                      setEditGradeVisible(true);
                    } else if (type === "class") {
                      setEditClassVisible(true);
                    }
                  }}
                >
                  编辑当前项
                </Button>

                <Popconfirm
                  visible={deleteVisible}
                  title="将会删除选中的项目和所有下属项目,确定删除吗?"
                  onConfirm={deleteConfirm}
                  onCancel={deleteCancel}
                  okText="确定"
                  cancelText="取消"
                >
                  <Button
                    className={styles["button"]}
                    ghost
                    type="primary"
                    shape="round"
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      if (currentHospital.id === -1) {
                        message.info("请在左边列表中选中一个项目,再进行删除!");
                      } else {
                        setDeleteVisible(true);
                      }
                    }}
                  >
                    删除当前项
                  </Button>
                </Popconfirm>
              </Space>
            </Col>
          </Row>
        </>)}
      <AddHospital
        visible={addHospitalVisible}
        add={hospitalAdd}
        addLogo={hospitalLogoAdd}
        setInvisible={() => setAddHospitalVisible(false)}
      />
      <AddSchool
        visible={addSchoolVisible}
        add={schoolAdd}
        setInvisible={() => setAddSchoolVisible(false)}
        hospital={currentHospital}
      />
      <AddGrade
        visible={addGradeVisible}
        add={gradeAdd}
        setInvisible={() => setAddGradeVisible(false)}
        schoolObj={currentSchool}
      />
      <AddClass
        visible={addClassVisible}
        add={classAdd}
        setInvisible={() => setAddClassVisible(false)}
        gradeObj={currentGrade}
      />

      <EditHospital
        visible={editHospitalVisible}
        update={hospitalUpdate}
        updateLogo={hospitalLogoUpdate}
        setInvisible={() => setEditHospitalVisible(false)}
        editRecord={currentHospital}
        editLogo={currentHospitalLogo}
      />
      <EditSchool
        visible={editSchoolVisible}
        update={schoolUpdate}
        setInvisible={() => setEditSchoolVisible(false)}
        editRecord={currentSchool}
      />
      <EditGrade
        visible={editGradeVisible}
        update={gradeUpdate}
        setInvisible={() => setEditGradeVisible(false)}
        editRecord={currentGrade}
      />
      <EditClass
        visible={editClassVisible}
        update={classUpdate}
        setInvisible={() => setEditClassVisible(false)}
        editRecord={currentClass}
      />
    </div>
  );
};
